import { Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface IMessage {
  readonly text: string
  readonly parentId: string
  readonly author: IAssociatedContact
  readonly seen: boolean
}

const MessageRecord = Record({
  author: undefined,
  parentId: '',
  seen: false,
  text: '',
})

export class Message extends MessageRecord implements IMessage {
  public static fromJS(initialState?: Partial<IMessage>) {
    if (!initialState) {
      return new Message()
    }

    const { author, ...rest } = initialState

    return new Message({
      author: AssociatedContact.fromJS(author),
      ...rest,
    })
  }

  public readonly text: string
  public readonly parentId: string
  public readonly author: IAssociatedContact
  public readonly seen: boolean

  constructor(initialState?: Partial<Message>) {
    initialState ? super(initialState) : super()
  }
}
